import { DynamicControl } from '../../../models/dynamic-form-control.model';

export class TableControl extends DynamicControl<any> {
    controlType = 'table';
    colSizes = [];
    columns;

    constructor(options: {} = {}) {
        super(options);
        this.colSizes = options["colSizes"];
        this.columns = options["columns"];
    }
}
